import { render, staticRenderFns } from "./ItemAddNew.vue?vue&type=template&id=25399e82&"
import script from "./ItemAddNew.vue?vue&type=script&lang=js&"
export * from "./ItemAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ItemAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports